import { render } from "./DescriptionLayout.vue?vue&type=template&id=3ec67c0a"
import script from "./DescriptionLayout.vue?vue&type=script&lang=js"
export * from "./DescriptionLayout.vue?vue&type=script&lang=js"

import "./DescriptionLayout.vue?vue&type=style&index=0&id=3ec67c0a&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__